import { useEffect, useState } from 'react'

const ParallaxBackground = () => {
  const [scrollY, setScrollY] = useState(0)

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY)
    }

    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <>
      {/* Fixed gradient background layer (z-0) */}
      <div className="fixed inset-0 pointer-events-none z-0">
        <div className="absolute inset-0 bg-gradient-to-r from-black via-[#2a2a2a] to-black" />
      </div>
      
      {/* Parallax logo layer - moves at 50% scroll speed (z-[8]) */}
      <div 
        className="fixed inset-0 pointer-events-none z-[8] overflow-hidden"
        style={{
          transform: `translateY(calc(66.666vh + ${scrollY * -0.5}px))`,
          transition: 'transform 0.1s ease-out'
        }}
      >
        <div className="absolute inset-0 flex items-center justify-center opacity-25">
          <img 
            src="/images/Logo-Praetorian_Works-Transparent-v1.png" 
            alt="" 
            className="w-full max-w-4xl h-auto object-contain"
            aria-hidden="true"
          />
        </div>
      </div>
    </>
  )
}

export default ParallaxBackground
